import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import infoIcon from "../../assets/images/icons/info.svg";

import styles from "./InputFrame.module.scss";

const InputFrame = ({
  error,
  requiredInput,
  withInfoIcon,
  labelPosition,
  errorMessage,
  disabled,
  label,
  className,
  children,
  name,
  inputClass
}) => {
  const leftPosition = labelPosition === "left";

  return (
    <div
      className={cx(className, styles.inputFrame, {
        [styles.inOneRow]: leftPosition
      })}
    >
      {label && (
        <label
          className={cx(styles.inputLabel, { [styles.disabledLabel]: disabled, [styles.leftPosition]: leftPosition })}
          htmlFor={name}
        >
          {label}
          {requiredInput && "*"}
          {withInfoIcon && <img src={infoIcon} className={cx(styles.infoIcon)} alt="" />}
          {leftPosition && ":"}
        </label>
      )}
      <div className={cx(styles.inputContainer)}>
        {children({
          inputClassName: cx(styles.inputControl, inputClass, {
            [styles.notValid]: error,
            [styles.disabledInput]: disabled
          })
        })}
        {errorMessage && error && <div className={cx(styles.inputError)}>{errorMessage}</div>}
      </div>
    </div>
  );
};

InputFrame.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  error: PropTypes.bool,
  withInfoIcon: PropTypes.bool,
  requiredInput: PropTypes.bool,
  disabled: PropTypes.bool,
  errorMessage: PropTypes.string,
  className: PropTypes.string,
  labelPosition: PropTypes.oneOf(["left", "top"]),
  children: PropTypes.func.isRequired,
  inputClass: PropTypes.string
};

InputFrame.defaultProps = {
  name: undefined,
  label: null,
  error: false,
  disabled: false,
  withInfoIcon: false,
  requiredInput: false,
  errorMessage: undefined,
  className: null,
  labelPosition: "top",
  inputClass: ""
};

export default InputFrame;
